import React from "react";
import { RolesDescription } from "../common/GeneralConfigurations";
import { userHasRolePermission } from "../../api/ApiUtils";
import { useTranslation } from "react-i18next";

import { Row, Col, Statistic, Typography, Card } from "antd";

import { Briefcase, TrendingUp, X, Home, Code, User } from "react-feather";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnMonthYearDropdown from "../common/adnMonthYearDropdown/AdnMonthYearDropdown";
import AdnSatisfactionLevel from "../common/adnSatisfactionLevel/AdnSatisfactionLevel";
import OffersDashboard from "../dashboard/OffersDashboard";
import FollowUpEventsDashboard from "../dashboard/FollowUpEventsDashboard";
import MontlyEventsCounterDashboard from "../dashboard/MontlyEventsCounterDashboard";
import "./Home.css";

const { Title } = Typography;

const HomeForm = ({
  handleColorChange,
  handleMonthChange,
  offerTypeData,
  employeeFollowUpEventData,
  loading,
  activeConsultantsCount,
  newConsultantsCount,
  resignatedConsultantsCount,
  handleModalClick,
  handleListConsultantsClick,
  handleActiveConsultantsClick,
  companySatisfaction,
  projectSatisfaction,
  clientSatisfaction,
  handleEmployeeFollowUpEventMonth,
  handleEmployeeFollowUpEventYear,
  handleOfferTypeMonth,
  handleOfferTypeYear,
  onRadioChange,
  monthlyEventsList,
  badgesColors,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={t("home.title")} />

      <Row className="statistic-row">
        <Card className="statistic-group">
          <h4>{t("home.consultants")}</h4>
          <Row className="statistic-card-row">
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card light-blue-card"
                onClick={() => handleActiveConsultantsClick()}
              >
                {
                  <Statistic
                    title={
                      <div className="statistic-card-header">
                        <div className="statistic-card-icon">
                          <Briefcase />
                        </div>
                        <p>{t("home.active")}</p>
                      </div>
                    }
                    value={activeConsultantsCount}
                    loading={loading}
                  ></Statistic>
                }
              </Card>
            </Col>
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card blue-card"
                onClick={() => handleListConsultantsClick(false)}
              >
                <Statistic
                  title={
                    <div className="statistic-card-header">
                      <div className="statistic-card-icon">
                        <TrendingUp />
                      </div>
                      <p>{t("home.new")}</p>
                    </div>
                  }
                  value={newConsultantsCount}
                  loading={loading}
                />
              </Card>
            </Col>
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card white-card"
                onClick={() => handleListConsultantsClick(true)}
              >
                <Statistic
                  title={
                    <div className="statistic-card-header">
                      <div className="statistic-card-icon">
                        <X />
                      </div>
                      <p>{t("home.resigned")}</p>
                    </div>
                  }
                  value={resignatedConsultantsCount}
                  loading={loading}
                />
              </Card>
            </Col>
          </Row>
        </Card>

        <Card className="statistic-group">
          <h4>{t("home.satisfaction")}</h4>
          <Row className="statistic-card-row">
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card light-blue-card"
                onClick={() => handleModalClick("Company")}
              >
                <AdnSatisfactionLevel
                  title={
                    <div className="statistic-card-header">
                      <div className="statistic-card-icon">
                        <Home />
                      </div>
                      <p>{t("home.company")}</p>
                    </div>
                  }
                  value={companySatisfaction}
                  loading={loading}
                />
              </Card>
            </Col>
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card blue-card"
                onClick={() => handleModalClick("Project")}
              >
                <AdnSatisfactionLevel
                  title={
                    <div className="statistic-card-header">
                      <div className="statistic-card-icon">
                        <Code />
                      </div>
                      <p>{t("home.project")}</p>
                    </div>
                  }
                  value={projectSatisfaction}
                  loading={loading}
                />
              </Card>
            </Col>
            <Col>
              <Card
                style={{ height: "100%", cursor: "pointer" }}
                loading={loading}
                className="statistic-card white-card"
                onClick={() => handleModalClick("Client")}
              >
                <AdnSatisfactionLevel
                  title={
                    <div className="statistic-card-header">
                      <div className="statistic-card-icon">
                        <User />
                      </div>
                      <p>{t("home.client")}</p>
                    </div>
                  }
                  value={clientSatisfaction}
                  loading={loading}
                />
              </Card>
            </Col>
          </Row>
        </Card>
      </Row>

      <Card style={{ marginBottom: "1rem" }}>
        <MontlyEventsCounterDashboard
          monthlyEventsList={monthlyEventsList}
          onRadioChange={onRadioChange}
          handleMonthChange={handleMonthChange}
          handleColorChange={handleColorChange}
          badgesColors={badgesColors}
        />
      </Card>

      {(userHasRolePermission(RolesDescription.MarketingCommunication) ||
        userHasRolePermission(RolesDescription.HumanResources) ||
        userHasRolePermission(RolesDescription.Admin)) && (
        <Row className="dashboard-charts-row">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 12 }}
          >
            <Card className="employeeFUEColumns">
              <Row
                gutter={8}
                justify="space-between"
                style={{ marginBottom: "1rem" }}
              >
                <Title level={4}>{t("home.followUpEvent")}</Title>

                <Col span={12}>
                  <AdnMonthYearDropdown
                    handleMonthChange={handleEmployeeFollowUpEventMonth}
                    handleYearChange={handleEmployeeFollowUpEventYear}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: "1rem" }}>
                <Col span={24}>
                  <FollowUpEventsDashboard
                    employeeFollowUpEventData={employeeFollowUpEventData}
                  />
                </Col>
              </Row>
            </Card>
          </Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 12 }}
          >
            <Card>
              <Row
                gutter={8}
                style={{ marginBottom: "1rem" }}
                justify="space-between"
              >
                <Title level={4}>{t("home.offers")}</Title>

                <Col span={12}>
                  <AdnMonthYearDropdown
                    handleMonthChange={handleOfferTypeMonth}
                    handleYearChange={handleOfferTypeYear}
                  />
                </Col>
              </Row>
              <Row justify="center">
                <Col span={24}>
                  <OffersDashboard offerTypeData={offerTypeData} />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default HomeForm;
